/* Primary green pill CTA from the v0 prototype (components/beyond-turo/beyond-ui.tsx), shared by
   the /tnt-group page and the home sections it reuses. Every CTA on that page funnels into the
   transition assessment flow. */
const BRAND_GREEN = "#33F7BE";

export const ASSESSMENT_URL = "/transition-plan";

export function SpeakCta({ href = ASSESSMENT_URL, label = "Speak with an Expert", tone = "light" }) {
  const dark = tone === "dark";
  return (
    <a
      href={href}
      className="btn-pulse inline-flex items-center justify-center text-center px-7 py-4 sm:py-3.5 rounded-full text-base sm:text-sm font-semibold text-black transition-colors duration-200 hover:bg-[#2be0a8] active:scale-95"
      style={dark ? { backgroundColor: "#080808", color: "#fcfcfc" } : { backgroundColor: BRAND_GREEN }}
    >
      {label}
    </a>
  );
}
